import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';

const AccountSetupStep = ({ formData, onChange }) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-3 mb-6">
        <Icon name="UserCog" size={24} className="text-blue-600" />
        <div>
          <h2 className="text-xl font-bold text-gray-900">Configuration du Compte</h2>
          <p className="text-sm text-gray-600">Identifiants d'accès au dashboard</p>
        </div>
      </div>

      <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-6">
        <div className="flex items-start gap-3">
          <Icon name="AlertTriangle" size={20} className="text-yellow-600 flex-shrink-0 mt-0.5" />
          <div className="text-sm text-yellow-800">
            <p className="font-medium mb-1">Informations importantes</p>
            <p>
              Ces identifiants permettront au praticien d'accéder à son dashboard personnel.
              Un email de confirmation sera envoyé automatiquement.
            </p>
          </div>
        </div>
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Nom Complet <span className="text-red-500">*</span>
        </label>
        <Input
          value={formData?.accountFullName}
          onChange={(e) => onChange?.('accountFullName', e?.target?.value)}
          placeholder="Dr Jean Dupont"
          required
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Email de Connexion <span className="text-red-500">*</span>
        </label>
        <Input
          type="email"
          value={formData?.accountEmail}
          onChange={(e) => onChange?.('accountEmail', e?.target?.value)}
          placeholder="dr.dupont@cabinet.fr"
          required
        />
        <p className="mt-1 text-xs text-gray-500">
          Cet email sera utilisé pour se connecter au dashboard
        </p>
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Mot de Passe <span className="text-red-500">*</span>
        </label>
        <div className="relative">
          <Input
            type={showPassword ? 'text' : 'password'}
            value={formData?.accountPassword}
            onChange={(e) => onChange?.('accountPassword', e?.target?.value)}
            placeholder="••••••••"
            className="pr-10"
            required
          />
          <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            className="absolute inset-y-0 right-0 pr-3 flex items-center"
          >
            <Icon 
              name={showPassword ? 'EyeOff' : 'Eye'} 
              size={20} 
              className="text-gray-400 hover:text-gray-600 transition-colors"
            />
          </button>
        </div>
        <p className="mt-1 text-xs text-gray-500">
          Minimum 8 caractères
        </p>
      </div>

      {/* Password Strength Indicator */}
      {formData?.accountPassword && (
        <div className="space-y-2">
          <div className="flex items-center gap-2">
            <div className="flex-1 h-2 bg-gray-200 rounded-full overflow-hidden">
              <div 
                className={`h-full transition-all ${
                  formData?.accountPassword?.length < 8 
                    ? 'bg-red-500 w-1/3' 
                    : formData?.accountPassword?.length < 12 
                    ? 'bg-yellow-500 w-2/3' :'bg-green-500 w-full'
                }`}
              />
            </div>
            <span className="text-xs font-medium text-gray-600">
              {formData?.accountPassword?.length < 8 
                ? 'Faible' 
                : formData?.accountPassword?.length < 12 
                ? 'Moyen' :'Fort'
              }
            </span>
          </div>
        </div>
      )}

      {/* Permissions */}
      <div className="bg-gray-50 rounded-lg p-4 border border-gray-200">
        <h3 className="text-sm font-semibold text-gray-700 mb-3 flex items-center gap-2">
          <Icon name="Shield" size={18} />
          Permissions du Compte
        </h3>
        <div className="space-y-2 text-sm text-gray-600">
          <div className="flex items-center gap-2">
            <Icon name="Check" size={16} className="text-green-600" />
            <span>Accès au dashboard personnel</span>
          </div>
          <div className="flex items-center gap-2">
            <Icon name="Check" size={16} className="text-green-600" />
            <span>Visualisation des référals reçus</span>
          </div>
          <div className="flex items-center gap-2">
            <Icon name="Check" size={16} className="text-green-600" />
            <span>Gestion du profil et branding</span>
          </div>
          <div className="flex items-center gap-2">
            <Icon name="X" size={16} className="text-red-600" />
            <span>Pas d'accès aux autres praticiens</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountSetupStep;